export const Config = {
  production: false,
  evt_app: "rGenOhFlJnk80ELN0xUzuNJtik5nYaxmZcF6fpE0OKwZdLkTS7yEF6zxvbrQtOxnVg3MvBgo2gWXcx2F",
  evt_base_url: "https://api-eu.evrythng.com",
  projectId: "UnSptk5ne6s7QNRawgMDtDge",
  appId: "UHbKt2qUe6s7QrwaRgMg9gkd",
  auth0:{
    clientID: '67JAI87YgeGyMWDBKZHedJ9LccRcjBC7',
    domain: 'evtjandj.eu.auth0.com',
    responseType: 'token id_token',
    audience: 'https://evtjandj.eu.auth0.com/userinfo',
    redirectUri: window.location.origin,//'http://localhost:8100',
    scope: 'openid'
  },
  ext_links:{
    privacyPolicy:"//www.neutrogena.co.uk/privacypolicy",
    cookiePolicy: "//www.neutrogena.co.uk/cookie-policy",
    legalNotice:"//www.neutrogena.co.uk/legal-statement",
    slaveryAct:"//www.neutrogena.co.uk/sites/neutrogena.co.uk/files/modern_slavery_act_statement.pdf",
    reorder: "//www.neutrogena.co.uk/product/visibly-clear-light-therapy-acne-mask-activator"
  },
  reorder_links: [
    {
      link: "https://www.amazon.co.uk/Neutrogena-Visibly-Clear-Therapy-Activator/dp/B01MU9ML3G/ref=sr_1_2_s_it?s=beauty&ie=UTF8&qid=1509712796&sr=1-2&keywords=neutrogena+light+therapy+acne+mask",
      name: "Amazon",
      target: "_blank"
    },{
      link: "http://www.boots.com/neutrogena-light-acne-therapy-mask-applicator-10229139",
      name: "Boots",
      target: "_blank"
    },{
      link: "https://www.superdrug.com/Skin/Face/Face-Masks/Neutrogena-Visibly-Clear-Acne-Mask-Activator/p/737374",
      name: "Superdrug",
      target: "_blank"
    },{
      link: "https://www.lookfantastic.com/neutrogena-visibly-clear-light-therapy-mask-activator/11433855.html",
      name: "Lookfantastic",
      target: "_blank"
    },{
      link: "https://www.ocado.com/webshop/product/Neutrogena-Light-Therapy-Acne-Mask-Activator/357890011?from=search&tags=%7C20000&param=neutrogena+activator&parentContainer=SEARCHneutrogena+acti",
      name: "Ocado",
      target: "_blank"
    },
  ],
  aura_url: {
    link: "https://www.aurahealth.io/",
    name: "AURA health",
    target: "_blank"
  },
  desktop_scan_url: {
    link: "scan.neutrogena.co.uk",
    name: "scan.neutrogena.co.uk",
    target: "_blank"
  },
  neutrogena_url: {
    link: "www.neutrogena.co.uk",
    name: "www.neutrogena.co.uk",
    target: "_blank"
  },
  neutrogena_reorder_url: {
    link: "http://www.neutrogena.co.uk/product/visibly-clear-light-therapy-acne-mask-activator",
    name: "VISIBLY CLEAR® Light Therapy Acne Mask Activator",
    target: "_blank"
  },
  idomoo:{
    outFormat: "VIDEO_MP4_V_X264_360X640_800_A_AAC_128",//"VIDEO_MP4_V_X264_360X640_1600_A_AAC_128",
    outFormat2:  "VIDEO_HLS_V_X264_360X640_1600_A_AAC_128",
    storyboardId:  15940,//15614;
    accountId:  2474,//2282;
    secret:  "8DGLDfTkKM8dd2cf8339c7f286c28687e8b0aa6e533TTTjSNDar",//"RWf6jfWyVSe644c28ec48697446aa93288b9a925451YoxkSmH7h";
    link:  "https://usa-api.idomoo.com/api/cg"
  },
  cloudinary:{

  },
  age_gate_expiry: 30,
  lessonCompletionTimeLimit: 10 * 60, //seconds till content consumption completion event is triggered
  totalDailyLessonLimit: 10, //lesson completion count
  courseDailyLessonLimit: 1, //lesson completion count
  anonUserLessonLimit: 1, //lesson count allowed for anonymous user
  anonUserDaysToSignInNotice: 2, //days until an anon user will see a pop-up to sign-in / sign-up
  thngDaysLifeSpan: 30, //the number of days that the activator is meant for. expires cookie and a new one is set
  dayToReorderNotice: 23, //day N of 30 (THNG life span) days before a logged-in user will see a pop-up since sign-up
  fbUserMetadataNS: 'http://evt-neutrogena-test.netlify.com/', //namespace used on rules for FB log-in
  scanRevertExpiry: 24 // hours until the app sets the scan as homepage instead of the aura content page
};



// WEBPACK FOOTER //
// ./src/config/environment.ts